// Function to create and show back button
function createBackButton(linkText = '') {
    let backButton = document.querySelector('.kiks-back-button');

    if (!backButton) {
        backButton = document.createElement('span');
        backButton.className = 'kiks-back-button';
        backButton.innerHTML = `
            <div class="kiks-back-button-content">
                <svg width="16" height="16" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg" style="fill: none; transform: rotate(90deg);">
                    <path d="M0.75 1.625L4.5 5.375L8.25 1.625" stroke="currentcolor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                Main menu
            </div>
            <div class="perent-link-content">${linkText}</div>
        `;

        backButton.addEventListener('click', function () {
            closeAllSlideMenus();
        });

        const closeContainer = document.querySelector('.x-container-mobile-nav .x-block-mobile-nav-close');
        if (closeContainer) {
            closeContainer.insertBefore(backButton, closeContainer.firstChild);
        }
    } else {
        // Update the perent-link-content if button already exists
        const perentLinkContent = backButton.querySelector('.perent-link-content');
        if (perentLinkContent) {
            perentLinkContent.textContent = linkText;
        }
    }

    backButton.style.display = 'flex';
}

// Function to hide back button
function hideBackButton() {
    const backButton = document.querySelector('.kiks-back-button');
    if (backButton) {
        backButton.style.display = 'none';
    }
}

// Function to close all slide menus
function closeAllSlideMenus() {
    const openSlideMenus = document.querySelectorAll('.kiks-slide-menu.kik-open-slide');
    openSlideMenus.forEach(function (slideMenu) {
        slideMenu.classList.remove('kik-open-slide');

        const parentLinks = slideMenu.querySelectorAll('.kiks-perent-link.kik-open-slide');
        parentLinks.forEach(function (link) {
            link.classList.remove('kik-open-slide');
            link.setAttribute('aria-expanded', 'false');
        });
    });

    hideBackButton();
}

// Function to prepare slide menu for animation and expand parent link
function prepareSlideMenu(link) {
    const slideMenu = link.closest('.kiks-slide-menu');
    if (!slideMenu) return;

    const menuDrawer = slideMenu.querySelector('.menu-drawer');
    if (!menuDrawer) return;

    menuDrawer.style.removeProperty('display');
    menuDrawer.style.removeProperty('height');
    menuDrawer.style.removeProperty('overflow');

    const originalRight = menuDrawer.style.right;
    const originalDisplay = menuDrawer.style.display;
    const originalPosition = menuDrawer.style.position;

    menuDrawer.style.right = '0';
    menuDrawer.style.display = 'block';
    menuDrawer.style.position = 'static';
    menuDrawer.style.visibility = 'hidden';
    menuDrawer.style.height = 'auto';
    menuDrawer.style.maxHeight = 'none';

    menuDrawer.offsetHeight;

    const scrollHeight = menuDrawer.scrollHeight;
    const offsetHeight = menuDrawer.offsetHeight;
    const clientHeight = menuDrawer.clientHeight;

    const contentHeight = Math.max(scrollHeight, offsetHeight, clientHeight);

    menuDrawer.style.right = originalRight;
    menuDrawer.style.display = originalDisplay;
    menuDrawer.style.position = originalPosition;
    menuDrawer.style.visibility = '';
    menuDrawer.style.height = '';
    menuDrawer.style.maxHeight = '';

    link.style.setProperty('--menu-drawer-height', contentHeight + 'px');
}

// Function to initialize all slide menus
function initializeSlideMenus() {
    const slideMenus = document.querySelectorAll('.kiks-slide-menu');

    slideMenus.forEach(function (slideMenu) {
        const menuDrawer = slideMenu.querySelector('.menu-drawer');
        if (menuDrawer) {
            menuDrawer.style.removeProperty('display');
            menuDrawer.style.removeProperty('height');
            menuDrawer.style.removeProperty('overflow');
        }
    });
}

// Use event delegation to handle dynamically loaded content
document.addEventListener('click', function (e) {
    if (e.target.closest('.kiks-perent-link')) {
        const link = e.target.closest('.kiks-perent-link');

        e.preventDefault();
        e.stopPropagation();

        const isExpanded = link.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
            link.classList.remove('kik-open-slide');
            link.setAttribute('aria-expanded', 'false');
            const slideMenu = link.closest('.kiks-slide-menu');
            if (slideMenu) slideMenu.classList.remove('kik-open-slide');

            setTimeout(() => {
                const openMenus = document.querySelectorAll('.kiks-slide-menu.kik-open-slide');
                if (openMenus.length === 0) {
                    hideBackButton();
                }
            }, 100);
        } else {
            link.classList.add('kik-open-slide');
            link.setAttribute('aria-expanded', 'true');
            const slideMenu = link.closest('.kiks-slide-menu');
            if (slideMenu) slideMenu.classList.add('kik-open-slide');

            // Get the text from the clicked parent link
            const linkTextElement = link.querySelector('.p-break-words');
            const linkText = linkTextElement ? linkTextElement.textContent.trim() : '';

            createBackButton(linkText);

            setTimeout(() => {
                prepareSlideMenu(link);
            }, 50);
        }
    }
});

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function () {
    initializeSlideMenus();

    setTimeout(function () {
        const parentLinks = document.querySelectorAll('.kiks-perent-link');

        if (parentLinks.length === 0) {
            return;
        }

        parentLinks.forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const isExpanded = this.getAttribute('aria-expanded') === 'true';

                if (isExpanded) {
                    this.classList.remove('kik-open-slide');
                    this.setAttribute('aria-expanded', 'false');
                    const slideMenu = this.closest('.kiks-slide-menu');
                    if (slideMenu) slideMenu.classList.remove('kik-open-slide');

                    setTimeout(() => {
                        const openMenus = document.querySelectorAll('.kiks-slide-menu.kik-open-slide');
                        if (openMenus.length === 0) {
                            hideBackButton();
                        }
                    }, 100);
                } else {
                    this.classList.add('kik-open-slide');
                    this.setAttribute('aria-expanded', 'true');
                    const slideMenu = this.closest('.kiks-slide-menu');
                    if (slideMenu) slideMenu.classList.add('kik-open-slide');

                    // Get the text from the clicked parent link
                    const linkTextElement = this.querySelector('.p-break-words');
                    const linkText = linkTextElement ? linkTextElement.textContent.trim() : '';

                    createBackButton(linkText);

                    setTimeout(() => {
                        prepareSlideMenu(this);
                    }, 50);
                }
            });
        });
    }, 100);
});
